<template>
  <div class="main-content-sidebar">
    <div class="main-content-sidebar_wrap">
      <slot></slot>

      <div
        class="main-content-sidebar__item"
        v-for="(item, index) in menus"
        :key="index"
        :class="{ actived: index === actived, disabled: loading }"
        @click="change(index)"
      >
        <i
          class="sidebar-item__icon"
          :class="item.icon"
          :style="`color: ${colors[index % colors.length]}`"
        ></i>
        <div class="sidebar-item__title">{{ item.title }}</div>
        <div v-if="item.subtitle" class="sidebar-item__subtitle">
          ({{ item.subtitle }})
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/** Props menus
 *    title [String]
 *    icon [String]
 */
export default {
  props: {
    actived: Number,
    loading: Boolean,
    menus: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      colors: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#41B883',
        '#cc65fe',
        '#bda29a',
        '#f28f43',
        '#a6c96a',
        '#546570',
        '#77a1e5'
      ]
    }
  },
  methods: {
    change(index) {
      if (!this.loading) {
        this.$emit('change', index)
      }
    }
  }
}
</script>

<style lang="scss">
.main-content-sidebar {
  overflow-x: hidden;
  overflow-y: auto;
  .main-content-sidebar_wrap {
  }
  .main-content-sidebar__item:hover {
    color: #409eff;
  }
  .actived {
    color: #409eff;
  }
  .sidebar-item__icon {
    font-size: 1.5rem;
    margin-bottom: 8px;
  }
  .sidebar-item__title {
    font-size: 12px;
    user-select: none;
  }
  .sidebar-item__subtitle {
    font-size: 12px;
    user-select: none;
  }
  .disabled {
    // pointer-events: none;
    cursor: wait !important;
  }
}
</style>
